import Test from '../../components/icons/Test';
import { QuestionOptions, QuestionSchema } from './Questions.types';
import useDelete from '~/lib/useDelete';
import { setFormDetailsQuery } from '~/lib/Queries';
import { isValid, parse } from 'date-fns';

// Date answers are stored human readable, ex. "March 5, 2026"
export const DATE_QUESTION_FORMAT = 'LLLL d, yyyy';

export function getIcon(questionSchema: QuestionSchema) {
    const MyIcon = questionSchema?.icon || Test;
    return ({ className }: { className?: string }) => (
        <div className={className}>
            <MyIcon />
        </div>
    );
}

export function getOptionsFromList(options: QuestionOptions) {
    return options.map(opt => opt?.trim()).filter(opt => !!opt);
}

export function getFormQuestionSchema(question, objectSchema) {
    return objectSchema.filter(o => o.key === `question-${question.id}`)[0];
}

/**
 * Answers can come from places we don't control (prefills, url params, imports),
 * so only trust a date answer we can actually parse back into a real date
 */
export function parseDateAnswer(answer): Date | null {
    if (!answer || typeof answer !== 'string') {
        return null;
    }

    const parsed = parse(answer, DATE_QUESTION_FORMAT, new Date(2000, 0, 1));

    return isValid(parsed) ? parsed : null;
}

export function isSchedulingAnswerValid(answer) {
    return answer && answer[0]?.startTime && !answer[0]?.zeroQuantity;
}

export function useDeleteQuestion(formId, question) {
    const {isDeleting, saveDelete} =  useDelete(
        `/forms/${formId}/sections/${question?.form_section_id}/questions/${question?.id}/delete`,
    );

    return {
        isDeleting,
        saveDelete: () => {
            return saveDelete().then((result) => {
                setFormDetailsQuery(formId, result);
            });
        }
    }
}
